module.exports = __webpack_public_path__ + "assets/img/ty6.0473c70a.jpg";